'use strict';
(function () {

    var _ = require('lodash'),
        $ = require('jquery'),
        page = require('page'),
        TweenMax = require('gsap'),
        MapData = require('json!../data/map.json'),
        Map = require('./map'),
        IntroView = require('./intro'),
        QuizView = require('./quiz'),
        LocationView = require('./location'),
        PanControls = require('./pan-controls');

    TweenMax.defaultOverwrite = "all";

    require('./util/event');
    require('./threejs/TweenMaxThreeJSPlugin');

    var app,
        _introview = new IntroView(),
        _quizview = new QuizView(),
        _locationview = new LocationView(),
        _currentView,
        _viewChangeStart = function(context, next){
            if(_currentView){
                if(_currentView.name === 'quiz-view' && context.path.search(/\/question\//g) > -1) {
                    
                } else if(_currentView.name === 'location-view' && context.path.search(/\/map\//g) > -1) {
                    
                } else {
                    _currentView.playOut();
                }
                if(_currentView.name !== undefined){
                    document.body.classList.remove(_currentView.name);
                };
            }
            next();
        },
        _viewChangeComplete = function(){
            if(_currentView && _currentView.name !== undefined){
                document.body.classList.add(_currentView.name);
            };
        },
        _intro = function (context, next) {
            _currentView = _introview;
            _currentView.playIn();
            this.currentView = _currentView;
            this.map.flipBlocks();
            this.map.gotoIntro();
            this.map.hideNumbers();
            this.map.hideStreets();
//            this.map.hideLabels();
            this.map.showOffice();
            this.map.hideControls();
            this.map.hideZoom();
            next();
        },
        _quiz = function (context, next) {
            
            this.map.flipBlocks();
            
            var data;
            _.each(MapData.quiz.questions, function(question){
                if(parseFloat(question.id) === parseFloat(context.params.id)){
                    data = question;
                }
            });
            
            if(!data) {
                return;
            }
                    
            if(_currentView && _currentView.name === _quizview.name){
                _currentView.update(data);
                
            } else {
                _currentView = _quizview;
                _currentView.init(data);
                _currentView.playIn();
                this.currentView = _currentView;
                this.map.gotoQuiz();
//                this.map.hideLocation();
                this.map.hideNumbers();
                this.map.hideStreets();
                this.map.hideControls();
                this.map.showOffice();
                
            }
            next();
        },
        _map = function (context, next) {
            
            var data;
            _.each(MapData.quiz.results, function(result){
                if(parseFloat(result.no) === parseFloat(context.params.id)){
                    data = result;
                }
            });
                
            if(_currentView && _currentView.name === _locationview.name){
                _currentView.update(data);
                
            } else {
                _currentView = _locationview;
                _currentView.init(data);
                _currentView.playIn();
    //            this.map.flipBlocks();
                this.map.gotoDefault();
                this.map.showOffice();
                this.map.showNumbers();
                this.map.showStreets();
                this.map.showLabels();
                this.map.showControls();
            }
            
            if(!data) {
                this.map.deselect();
                this.map.showZoom();
            } else if(document.body.classList.contains('mobile')) {
                this.map.hideZoom();
            } else if(!document.body.classList.contains('mobile')) {
                this.map.showZoom();
            }
            
            if(context.params.id){
                this.map.select(context.params.id);
            }
        
            next();
        };
    var App = function () {};
    App.prototype = {
        init: function () {
            
            _.bindAll(this);

            page({
                popstate: false,
                hashbang: true,
                dispatch: false
            });


            page('/quiz/question/:id', _viewChangeStart, _.bind(_quiz, this), _viewChangeComplete);
            page('/map', _viewChangeStart, _.bind(_map, this), _viewChangeComplete);
            page('/map/:id', _viewChangeStart, _.bind(_map, this), _viewChangeComplete);
            page('*', _viewChangeStart, _.bind(_intro, this), _viewChangeComplete);

            this.map = new Map();
            this.controls = new PanControls(this.map);
            this.controls.enable();
            
            window.onhashchange();


        }


    };



    document.addEventListener("DOMContentLoaded", function () {
        window.app = app = new App();
        window.addEventListener('resize', function(){
            console.log(window.innerWidth)
            if(window.innerWidth <= 960){
                document.body.classList.add('mobile');
            } else {
                document.body.classList.remove('mobile');
            }
        });
        window.dispatchEvent(new Event('resize'));
        window.onhashchange = function () {
            var path = window.location.hash; //.replace(/#!\/*/, '');
//            var path = window.location.hash.replace(location.pathname, '');
            page(path);
        }
        app.init();
        

        document.ontouchmove = function (event) {
            event.preventDefault();
        };
    });

}());


/** WEBPACK FOOTER **
 ** ./holiday-map/main.js
 **/